<template>
  <div class="-my-2 h-[calc(100vh-240px)] overflow-x-auto overflow-y-auto px-4">
    <div class="inline-block w-full py-2">
      <table class="w-full divide-y divide-slate-100 bg-white sm:rounded-t-lg">
        <thead class="text-x border-b border-gray-200 bg-gray-50 text-primary">
          <tr>
            <th
              class="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-700"
            >
              Question
            </th>
            <th
              scope="col"
              class="px-6 py-3 font-medium"
            >
              <div class="flex items-center gap-1">
                <span
                  class="text-left text-xs uppercase tracking-wider text-gray-700"
                >theme</span>
                <div class="relative z-50">
                  <button
                    class="text-gray-400 outline-none"
                    :class="{ 'bg-gray-100 text-gray-700': showThemeFilter }"
                    @click="showThemeFilter = !showThemeFilter"
                  >
                    <FilterIcon custom-style="h-4 w-4" />
                  </button>
                  <div
                    v-if="showThemeFilter"
                    class="absolute left-0 top-[105%] z-50"
                  >
                    <div class="rounded-lg bg-white shadow-md">
                      <div
                        class="place-content-center px-8 py-4 text-[#68737D]"
                      >
                        <InputWithIcon
                          :val="searchThemeName"
                          classes="py-3 rounded-lg"
                          placeholder="Search..."
                          @input="searchThemeName = $event"
                        >
                          <template #icon>
                            <SearchIcon />
                          </template>
                        </InputWithIcon>
                      </div>
                      <div class="relative max-h-[250px] overflow-y-auto">
                        <div
                          v-for="(
                            item, labelIndex
                          ) in listFilterPublishedThemes"
                          :key="labelIndex"
                        >
                          <label
                            for="checkbox"
                            :class="`items-cente font-inter flex w-full cursor-pointer px-8 py-3 text-base font-normal text-primary ${checkedTheme.includes(item.theme) ? 'bg-gray-50' : ''}`"
                          >
                            <input
                              v-model="checkedTheme"
                              :value="item.theme"
                              type="checkbox"
                              class="mr-3 cursor-pointer rounded-sm border-2 border-gray-300 bg-white px-3 py-3 text-main-primary hover:border-gray-500 focus:border-main-primary focus:ring-transparent"
                            >
                            <span
                              class="text-md select-none whitespace-nowrap"
                            >{{ item.theme }}</span>
                          </label>
                        </div>
                      </div>
                      <hr class="mx-8 my-4 h-0.5 border-0 bg-gray-100">
                      <div
                        class="flex w-full items-center justify-between gap-3 px-8 pb-4"
                      >
                        <GhostButton
                          classes="px-16"
                          @click="showThemeFilter = false"
                        >
                          Cancel
                        </GhostButton>
                        <PrimaryButton
                          classes="px-16"
                          @click="applyThemeTopicFilter"
                        >
                          Apply
                        </PrimaryButton>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </th>
            <th
              scope="col"
              class="px-6 py-3 font-medium"
            >
              <div class="flex items-center gap-1">
                <span
                  class="text-left text-xs uppercase tracking-wider text-gray-700"
                >topic</span>
                <div class="relative z-[100]">
                  <button
                    class="text-gray-400 outline-none"
                    :class="{ 'bg-gray-100 text-gray-700': showTopicFilter }"
                    @click="showTopicFilter = !showTopicFilter"
                  >
                    <FilterIcon custom-style="h-4 w-4" />
                  </button>
                  <div
                    v-if="showTopicFilter"
                    class="absolute left-0 top-[105%] z-50"
                  >
                    <div class="rounded-lg bg-white shadow-md">
                      <div
                        class="place-content-center px-8 py-4 text-[#68737D]"
                      >
                        <InputWithIcon
                          :val="searchTopicName"
                          classes="py-3 rounded-lg"
                          placeholder="Search..."
                          @input="searchTopicName = $event"
                        >
                          <template #icon>
                            <SearchIcon />
                          </template>
                        </InputWithIcon>
                      </div>
                      <div class="relative max-h-[250px] overflow-y-auto">
                        <div
                          v-for="(
                            item, labelIndex
                          ) in listFilterPublishedTopics"
                          :key="labelIndex"
                        >
                          <label
                            for="checkbox"
                            :class="`items-cente font-inter flex w-full cursor-pointer px-8 py-3 text-base font-normal text-primary ${checkedTopic.includes(item.name) ? 'bg-gray-50' : ''}`"
                          >
                            <input
                              v-model="checkedTopic"
                              :value="item.name"
                              type="checkbox"
                              class="mr-3 cursor-pointer rounded-sm border-2 border-gray-300 bg-white px-3 py-3 text-main-primary hover:border-gray-500 focus:border-main-primary focus:ring-transparent"
                            >
                            <span
                              class="text-md select-none whitespace-nowrap"
                            >{{ item.name }}</span>
                          </label>
                        </div>
                      </div>
                      <hr class="mx-8 my-4 h-0.5 border-0 bg-gray-100">
                      <div
                        class="flex w-full items-center justify-between gap-3 px-8 pb-4"
                      >
                        <GhostButton
                          classes="px-16"
                          @click="showTopicFilter = false"
                        >
                          Cancel
                        </GhostButton>
                        <PrimaryButton
                          classes="px-16"
                          @click="applyThemeTopicFilter"
                        >
                          Apply
                        </PrimaryButton>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </th>
            <th
              class="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-700"
            >
              Index
            </th>
            <th
              class="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-700"
            >
              Published at
            </th>
          </tr>
        </thead>
        <tbody v-show="publishedQuestions.length">
          <tr
            v-for="(
              { title, theme, section, index, published_at }, qnIndex
            ) in publishedQuestions"
            :key="qnIndex"
            class="gap-2 border bg-white shadow-md"
          >
            <td class="whitespace-nowrap px-6 py-4 text-sm text-gray-500">
              <div class="w-[600px]">
                <span class="block overflow-hidden truncate">
                  {{ title }}
                </span>
              </div>
            </td>
            <td class="whitespace-nowrap px-6 py-4 text-sm text-gray-500">
              {{ theme }}
            </td>
            <td class="whitespace-nowrap px-6 py-4 text-sm text-gray-500">
              {{ section }}
            </td>
            <td class="whitespace-nowrap px-6 py-4 text-sm text-gray-500">
              {{ index }}
            </td>
            <td class="whitespace-nowrap px-6 py-4 text-sm text-gray-500">
              {{ $moment(published_at).format("MMM DD, YYYY - HH:mm") }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PublishedQuestionsTable',

  props: {
    questions: {
      type: Array,
      required: true,
    },
    publishedItems: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      publishedQuestions: this.transformQuestions(this.questions),
      loadedQuestions: this.transformQuestions(this.questions),
      allFilters: [],
      listFilterPublishedThemes: this.publishedItems.themes,
      listFilterPublishedTopics: this.publishedItems.topics,
      searchThemeName: '',
      searchTopicName: '',
      checkedTopic: [],
      checkedTheme: [],
      showThemeFilter: false,
      showTopicFilter: false,
      filterQueryString: null,
    }
  },

  watch: {
    questions(newQuestions) {
      this.publishedQuestions = this.transformQuestions(newQuestions)
    },
    searchTopicName(query) {
      const queryList = [...this.publishedItems.topics]
      this.listFilterPublishedTopics
        = query === ''
          ? queryList
          : queryList.filter(({ name }) =>
            name.toLowerCase().includes(query.toLowerCase()),
          )
    },
    searchThemeName(query) {
      const queryList = [...this.publishedItems.themes]
      this.listFilterPublishedThemes
        = query === ''
          ? queryList
          : queryList.filter(({ theme }) =>
            theme.toLowerCase().includes(query.toLowerCase()),
          )
    },
  },

  methods: {
    transformQuestions(loadedQuestions) {
      return loadedQuestions.filter(({ status }) => status === 'published')
      // const groupedByTheme = groupBy(questions, 'theme')

      // // Sort by ascending order number and date published
      // Object.keys(groupedByTheme).forEach(theme =>
      //   groupedByTheme[theme].sort((a, b) => {
      //     return a.order === b.order ? new Date(a.published_at) - new Date(b.published_at) : a.order - b.order
      //   }),
      // )

      // const publishedQuestions = [];
      // // Attach question index according to the date published
      // ['G', 'E', 'S'].forEach((theme) => {
      //   if (groupedByTheme[theme]) {
      //     const groupedByThemeOrder = groupBy(groupedByTheme[theme], 'order')
      //     Object.keys(groupedByThemeOrder).forEach((themeOrder) => {
      //       groupedByThemeOrder[themeOrder].forEach((themeOrderedQuestion, index) => {
      //         themeOrderedQuestion.publishedIndex = index + 1
      //         publishedQuestions.push(themeOrderedQuestion)
      //       })
      //     })
      //   }
      // })
      // return publishedQuestions
    },
    applyThemeTopicFilter() {
      this.showTopicFilter = false
      this.showThemeFilter = false
      if (this.checkedTopic.length === 0 && this.checkedTheme.length === 0) {
        this.publishedQuestions = [...this.loadedQuestions]
        return
      }
      if (this.checkedTopic.length === 0 && this.checkedTheme.length > 0) {
        this.publishedQuestions = [...this.loadedQuestions].filter(item =>
          this.checkedTheme.includes(item.theme),
        )
      }
      else if (
        this.checkedTopic.length > 0
        && this.checkedTheme.length === 0
      ) {
        this.publishedQuestions = [...this.loadedQuestions].filter(item =>
          this.checkedTopic.includes(item.section),
        )
      }
      else if (this.checkedTopic.length > 0 && this.checkedTheme.length > 0) {
        this.publishedQuestions = [...this.loadedQuestions].filter(
          item =>
            this.checkedTopic.includes(item.section)
            && this.checkedTheme.includes(item.theme),
        )
      }
      getCurrentInstance()?.proxy?.$forceUpdate()
    },
  },
}
</script>
